/**
 * ps_checkout_pickup.js
 * Checkout custom : au choix d'un magasin dans le dropdown « Magasin de retrait »
 * (#pdw_pickup_store), on affiche le magasin choisi (nom + adresse + téléphone) dans
 * l'encart de la colonne résumé (#pdw-pickup-selected), juste au-dessus du paiement
 * « Réservation… ». Les données viennent des data-attributs des <option> (alimentés par
 * la config Local Pickup de WooCommerce, champ « Details » = téléphone).
 *
 * ⚠️ #order_review (colonne droite) se re-render en AJAX (updated_checkout) → l'encart est
 *    recréé vide → on re-remplit sur cet event. Le <select> (colonne gauche) n'est PAS
 *    re-rendu → son listener persiste.
 */
(function () {
	function render() {
		var sel = document.querySelector( '#pdw_pickup_store' );
		var box = document.querySelector( '#pdw-pickup-selected' );
		if ( ! sel || ! box ) {
			return;
		}
		if ( ! sel.value ) {
			box.hidden = true;
			return;
		}
		var opt     = sel.options[ sel.selectedIndex ];
		var address = opt.getAttribute( 'data-address' ) || '';
		var details = opt.getAttribute( 'data-details' ) || '';

		var nameEl  = box.querySelector( '.pdw-pickup-selected-name' );
		var addrEl  = box.querySelector( '.pdw-pickup-selected-address' );
		var phoneEl = box.querySelector( '.pdw-pickup-selected-phone' );

		if ( nameEl ) { nameEl.textContent = opt.value; }
		if ( addrEl ) { addrEl.textContent = address; addrEl.hidden = ! address; }

		if ( phoneEl ) {
			phoneEl.innerHTML = '';
			if ( details ) {
				var digits = details.replace( /[^\d+]/g, '' );
				if ( digits.length >= 6 ) {
					var a = document.createElement( 'a' );
					a.href = 'tel:' + digits;
					a.textContent = details;
					phoneEl.appendChild( a );
				} else {
					phoneEl.textContent = details;
				}
				phoneEl.hidden = false;
			} else {
				phoneEl.hidden = true;
			}
		}

		box.hidden = false;
	}

	function bind() {
		var sel = document.querySelector( '#pdw_pickup_store' );
		if ( ! sel ) {
			return;
		}
		sel.addEventListener( 'change', render );
		render();
	}

	if ( document.readyState !== 'loading' ) {
		bind();
	} else {
		document.addEventListener( 'DOMContentLoaded', bind );
	}

	// Re-render après chaque rafraîchissement AJAX de la colonne résumé.
	if ( window.jQuery ) {
		var $ = window.jQuery;
		$( document.body ).on( 'updated_checkout', render );
		$( document.body ).on( 'change', '#pdw_pickup_store', render );

		// Pose / retire l'état d'erreur. ⚠️ On N'utilise PAS `::after` (un clearfix
		// `.form-row::after{content:"."}` l'occupe) ni la classe parente seule (la bordure de
		// base, ciblée par #id, gagnait) → on pose une classe SUR LE SELECT + un vrai <span>.
		function setPickupError( on ) {
			var sel   = document.querySelector( '#pdw_pickup_store' );
			var field = document.querySelector( '#pdw_pickup_store_field' );
			if ( ! sel || ! field ) {
				return;
			}
			if ( on ) {
				sel.classList.add( 'pdw-pickup-invalid' );
				// Bordure rouge forcée en inline !important (bat la bordure de base !important).
				sel.style.setProperty( 'border-color', '#e2401c', 'important' );
				sel.style.setProperty( 'box-shadow', '0 0 0 1px #e2401c', 'important' );
				field.classList.add( 'woocommerce-invalid', 'woocommerce-invalid-required-field' );
				field.classList.remove( 'woocommerce-validated' );
				if ( ! field.querySelector( '.pdw-pickup-error' ) ) {
					var span = document.createElement( 'span' );
					span.className = 'pdw-pickup-error';
					span.textContent = '⚠ Merci de choisir votre magasin de retrait.';
					field.appendChild( span );
				}
			} else {
				sel.classList.remove( 'pdw-pickup-invalid' );
				sel.style.removeProperty( 'border-color' );
				sel.style.removeProperty( 'box-shadow' );
				field.classList.remove( 'woocommerce-invalid', 'woocommerce-invalid-required-field' );
				field.classList.add( 'woocommerce-validated' );
				var e = field.querySelector( '.pdw-pickup-error' );
				if ( e ) { e.remove(); }
			}
		}

		// Retire l'erreur dès qu'un magasin est choisi.
		$( document.body ).on( 'change', '#pdw_pickup_store', function () {
			if ( this.value ) { setPickupError( false ); }
		} );

		// Bloque la validation de commande si aucun magasin → message inline clair + scroll.
		// ⚠️ WooCommerce déclenche `checkout_place_order` via triggerHandler SUR LE FORMULAIRE
		//    (pas sur document/body, et ça ne bubble pas) → on bind directement sur le form.
		function guardPickup() {
			var sel = document.querySelector( '#pdw_pickup_store' );
			if ( sel && ! sel.value ) {
				setPickupError( true );
				try { sel.scrollIntoView( { behavior: 'smooth', block: 'center' } ); } catch ( e ) {}
				return false; // stoppe la soumission
			}
			return true;
		}
		$( 'form.woocommerce-checkout, form.checkout' ).on( 'checkout_place_order', guardPickup );
		$( document.body ).on( 'checkout_place_order', guardPickup ); // filet selon versions WC
	}
})();
